<template>
  <div class="main-content-container container-fluid px-4" style="margin-top:-55px">
    <div class="page-header row no-gutters py-4">
      <div class="col-12 col-sm-4 text-center text-sm-left mb-0">
        <span class="text-uppercase page-subtitle">Inventory</span>
        <h3 class="page-title">Upload Asn</h3>
      </div>
    </div>
    <d-card class="card-small mb-4">
      <!-- Card Header -->
      <d-card-header class="border-bottom">
        <h6 class="m-0">Upload Asn</h6>

        <!-- <router-link :to="{ name: 'user-setup'}">
          <button
            class="btn btn-md btn-primary"
            style="margin-left: 900px;background-color:white;margin-top:-40px;color:black;"
          >Dashboard</button>
        </router-link> -->
      </d-card-header>

      <d-list-group flush>
        <d-list-group-item class="p-3">
          <d-row>
            <d-col>
              <d-form>
                <d-form-row>
                  <!-- Email -->

                  <d-col md="12" class="form-group row">
                    <label class="col-md-3 col-form-label">Upload Noon File</label>
                    <div class="col-md-7">
                                       <div class="col-md-7">  
                     <!-- <ejs-uploader ref="uploadObj" :uploading="importExcel"   id='Noonfileupload' name="UploadFiles"></ejs-uploader> -->
                         <div class="button_group">
                          <a href="javascript:;" class="button_s my_file el-button button_s el-button--primary el-button--small" >
                          <!-- <input type="file" class="my_input" name="Asin" id="upload" /> -->
                          <input type="file" id="avatar" @change="importExcel" name="avatar">
                          </a>
 
                          </div>
                    </div>
                    </div>
                  </d-col>

<!--  
                  <d-col md="12" class="form-group row">
                    <label class="col-md-3 col-form-label">Upload Amazon File</label>
                    <div class="col-md-7">
                     <ejs-uploader ref="uploadObj" id='Amazonfileupload' name="UploadFiles"></ejs-uploader>
                    </div>
                  </d-col> -->

 
                </d-form-row>
 
                <br />

                <div class style="text-align:center">
                  <d-button
                    type="button"
                    id="submit"
                    class="btn-accent"
                    @click="SubmitUsersetup"
                    style="margin-right:10px"
                  >Submit</d-button>
                  <d-button
                    type="button"
                    id="submit"
                    class="btn-accent"
                    @click="ClearUsersetup"
                  >Cancel</d-button>
                </div>
              </d-form>
            </d-col>
          </d-row>
        </d-list-group-item>
      </d-list-group>
    </d-card>
  </div>
</template>

<script>
import Utilities from "@/Utilities/Utilities";
import axios from "axios";
// import VueToast from "vue-toast-notification";
// import "vue-toast-notification/dist/theme-default.css";
// Vue.use(VueToast);

export default {
  name: "Usersetup",
  data() {
    return {
      Usersetup: {
        PageType: "Master", // Master, Transaction, Dashboard, Tabb edDashboard
        PageLoad: true, // block/none
        DataModel: {
          Data: {
            // User: {
            Id: 0,
            Username: null,
            Password: null,
            ConfirmPassword: null,
          },
          UIData: {},
        },
        PageState: "Default", // Default, Changed/Dirty, Submitted, PageLoading Dirty means some values are changed in the page
        TabInfo: {
          SelectedTabIndex: 0,
          NumberOfTabs: 0,
        },
        SessionInfo: {
          SessionTimeout: false,
          AuthToken: "",
          SessionID: "",
          PageInfo: {
            ClientId: 0,
            userId: 0,
            WareHouseId: 0,
          },
        },
        GridInfo: {},
        Events: {
          EventRaised: "Submitted", // Saved, Submitted, Cancelled, AutoCompletionTextChanged,
          PageToNavigateWhenSubmitted: "", // We can go back to dashboard or stay on the Same page or to a specific page
        },
        ValidationInfo: {},
        ErrorInfo: [
          {
            ErrorID: 1,
            ErrorName: "",
            ErrorMessage: "",
          },
        ],
        Masters: {
          UsersetupList: [],
        },
        Modal: {},
        CharRestrict: {},
      },
    };
  },
  mounted() {
    this.ListUsersetup();
  },
  methods: {
    Select() {
      console.log(this.Usersetup.DataModel.Data);
    },


    /**
     * Import table
     */
     importExcel(e) {

      const files = e.target.files;
      this.UploadSyncc.PageLoad = true;
      if (!files.length) {
        return ;
      } else if (!/\.(xls|xlsx)$/.test(files[0].name.toLowerCase())) {
        this.UploadSyncc.PageLoad = false;
        return alert("The upload format is incorrect. Please upload xls or xlsx format");
      }
      const fileReader = new FileReader();
      fileReader.onload = ev => {
        try {
          const data = ev.target.result;
          const XLSX = xlsx;
          const workbook = XLSX.read(data, {
            type: "binary"
          });
          const wsname = workbook.SheetNames[0]; // Take the first sheet，wb.SheetNames[0] :Take the name of the first sheet in the sheets
          const ws = XLSX.utils.sheet_to_json(workbook.Sheets[wsname]); // Generate JSON table content，wb.Sheets[Sheet名]    Get the data of the first sheet
          const excellist = []; // Clear received data
          // Edit data

     
          // console.log("Read results", this.UploadSyncc.DataModel.Data.SynccentricScrapList); // At this point, you get an array containing objects that need to be processed
          // Get header2-1
          const a = workbook.Sheets[workbook.SheetNames[0]];
          const headers = this.getHeader(a);
          console.log('headers', headers);  
          this.UploadSyncc.PageLoad = false;
          // console.log(this.UploadSyncc.DataModel.Data.QueryString); 
          // this.UploadSyncc.DataModel.Data.QueryString = JSON.stringify(this.UploadSyncc.DataModel.Data.QueryString); 
          // Get header2-2
        } catch (e) {
          console.log(e); 
            vm.UploadSyncc.PageLoad = false;
          return alert("Read failure!");;
        }
      };
      fileReader.readAsBinaryString(files[0]);
      var input = document.getElementById("upload");
    },
    SubmitUsersetup() {
      
 
    },

    ClearUsersetup() {
 
    },

    ListUsersetup() {
 
 
    },
    SelectMobileNumber() {
 
    },
  },
};
</script>
